import { ReactNode, useEffect } from "react";
import { useDispatch } from "react-redux";
import { setAppState } from "../../redux/features/appStateSlice";
import sizeConfigs from "../../configs/sizeConfigs";

type Props = {
  state?: string,
  children: ReactNode;
};

const PageWrapper = (props: Props) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (props.state) {
      dispatch(setAppState(props.state));
    }
  }, [dispatch, props]);

  return (
    <div id="page-wrapper" style={{marginTop: sizeConfigs.topbar.height}}>{props.children}</div>
  );
};

export default PageWrapper;